export default __webpack_public_path__ + "src/assets/icn-phishing.e90a811ed21f4875127d0c34a8ca286e.svg";